import React, {
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle,
} from 'react'
import { Marker, Tooltip, Circle, useMap } from 'react-leaflet'
import { validLatitude, validLongitude } from '../../../utils/UICommonFunction'
interface LocationMarkerProps {
  latitude?: any
  longitude?: any
  radius?: number
  plantName?: string
}
const LocationMarker = forwardRef((props: LocationMarkerProps, ref) => {
  const { latitude = 0, longitude = 0, radius, plantName } = props

  const map = useMap()
  const [location, setLocation] = useState<{ lat: number; lng: number }>({
    lat: 0,
    lng: 0,
  })
  const [plantRadius, setPlantRadius] = useState<number>(1600)
  useEffect(() => {
    if (radius && radius > 0) {
      setPlantRadius(radius * 1600)
    } else {
      setPlantRadius(1600)
    }
  }, [radius])
  useEffect(() => {
    const mapLocation = location
    if (validLatitude(latitude)) {
      mapLocation.lat = latitude
      setLocation(mapLocation)
    }
    if (validLongitude(longitude)) {
      mapLocation.lng = longitude
      setLocation(mapLocation)
    }
  }, [latitude, longitude, location])
  useImperativeHandle(ref, () => ({
    getMapLocation(latitude: any, longitude: any) {
      const mapLocation = location
      if (validLatitude(latitude)) {
        mapLocation.lat = latitude
        setLocation(mapLocation)
      }
      if (validLongitude(longitude)) {
        mapLocation.lng = longitude
        setLocation(mapLocation)
      }
      map.zoomControl.setPosition('bottomright')
      map.setView(location, 10)
      map.panTo(location)
    },
  }))

  return (
    <>
      <Circle
        key={plantName}
        center={[location.lat, location.lng]}
        fillColor={'blue'}
        radius={plantRadius}
        weight={1}
      />
      <Marker position={[location.lat, location.lng]}>
        <Tooltip direction="top" offset={[-15, -15]} permanent>
          {plantName}
        </Tooltip>
      </Marker>
    </>
  )
})
export default LocationMarker
